import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { instanceAPIPrivate } from 'config/axiosconfig';

const axiosConfig = {
  withCredentials: true,
};

export const setNotification = createAsyncThunk(
  'notify',
  async (id) => {
    const notification = await instanceAPIPrivate.get(`/notify-when-auction-start/${id}`, axiosConfig)
      .then((resp) => resp.data)
      .catch((err) => err.response.data);
    return notification;
  },
);

const notifySlice = createSlice({
  name: 'notify',
  initialState: {
    notify: {},
    statusNotify: '',
  },
  extraReducers: {
    [setNotification.pending]: (state) => {
      state.statusNotify = 'loading';
    },
    [setNotification.fulfilled]: (state, action) => {
      state.statusNotify = 'success';
      state.notify = action.payload;
    },
    [setNotification.rejected]: (state) => {
      state.statusNotify = 'failed';
    },
  },
  reducers: {
    resetNotify: (state) => {
      state.notify = {};
      state.statusNotify = '';
    },
  },
});

export const { resetNotify } = notifySlice.actions;
export default notifySlice.reducer;
